import { render } from "./modal-change-email.vue?vue&type=template&id=6e34f54f&ts=true"
import script from "./modal-change-email.vue?vue&type=script&lang=ts"
export * from "./modal-change-email.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__